"use client"

import { useSession } from 'next-auth/react'
import { useEffect, useState } from 'react'

// Cache em módulo: evita refetch a cada montagem do hook durante a navegação.
let cachedEmail: string | null = null
let cachedIsAdmin = false
let inflight: Promise<boolean> | null = null

async function fetchAdminStatus(email: string): Promise<boolean> {
  if (cachedEmail === email) return cachedIsAdmin
  if (!inflight) {
    inflight = fetch('/api/admin/status', { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : { isAdmin: false }))
      .then((data: { isAdmin?: boolean }) => {
        cachedEmail = email
        cachedIsAdmin = !!data.isAdmin
        return cachedIsAdmin
      })
      .catch(() => false)
      .finally(() => {
        inflight = null
      })
  }
  return inflight
}

export function useAdminStatus(): boolean {
  const { data: session, status } = useSession()
  const email = status === 'authenticated' ? session?.user?.email ?? null : null
  const [cached, setCached] = useState<{ email: string | null; isAdmin: boolean }>(() => ({
    email,
    isAdmin: email ? cachedEmail === email && cachedIsAdmin : false,
  }))

  const isAdmin = !!email && cached.email === email ? cached.isAdmin : false

  useEffect(() => {
    if (!email) return
    let active = true
    fetchAdminStatus(email).then((result) => {
      if (active) setCached({ email, isAdmin: result })
    })
    return () => {
      active = false
    }
  }, [email])

  return isAdmin
}
